module.exports = __webpack_public_path__ + "static/1_4_dark-5396b0bffd729a2229de076cb882ba84.png";